<template>
  <div class="c-resource" v-if="courseList.length">
    <div class="f-left" ref="container">
      <div class="selector-container"  >
        <course-selector
          v-model="selectedCourse"
          @list-change="courseList=$event"
          :data="courseList"
          :total="courseCount"
          :defaultName="activatedCourse.courseName"
        />
      </div>
      <chapter-list
        :data="chapterList"
        @toggle="onToggle"
        v-model="activatedCourse"
        :course="checkedCourse"
      />
    </div>
    <div class="f-main">
      <resource-content :data="activatedCourse" :subject-id="selectedSubjectId" />
    </div>
    <Guide :pos="pos" v-if="visibleGuide" @close="onCloseGuide" />
  </div>
  <div v-else>
    <Empty v-show="!isPad" />
  </div>
</template>

<script>
import { CRM_USER, CACHED_LO, GUIDE } from '@/config/storage';
// import { log } from '@/utils/log';
import _ from 'lodash';
import { getCourseList, getCourseTree } from '@/api/pt';
import ChapterList from './chapter-list.vue';
import { unlocking } from '@/utils/access-control';
import ResourceContent from './resource-content.vue';
import CourseSelector from './course-selector.vue';
import Guide from './guide.vue';
import { getSign } from '@/utils';
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'CourseResource',
  components: {
    ChapterList,
    ResourceContent,
    CourseSelector,
    Guide,
    Empty,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    // const cacheCourseList = JSON.parse(localStorage.getItem(CACHED_LO + userInfo.id)) || [];
    // const cachedCourse = _.get(cacheCourseList, '0', {});
    const visibleGuide = !localStorage.getItem(GUIDE + userInfo.id);
    return {
      userInfo,
      isPad: this.$route.query.spad,
      cachedCourse: {},
      visibleGuide,
      activatedCourse: {},
      activePoint: null,
      pos: {},
      pointList: [],
      selectedCourse: '',
      courseList: [],
      chapterList: [],
      courseCount: 0,
      courseTreeId: '',
    };
  },
  computed: {
    checkedCourse() {
      const course = this.courseList.find((item) => item.course_id === this.selectedCourse);
      if (!course) {
        return {
          courseId: '',
          courseName: '',
          subjectId: _.get(this.courseList, '0.subject_id'),
        };
      }
      return {
        courseId: course.course_id,
        courseName: course.course_name,
        subjectId: course.subject_id,
        textbookId: course.textbook_id,
      };
    },
    // TMD 本来只需要一个 id，现在需要一个对象
    selectedSubjectId() {
      return this.checkedCourse && this.checkedCourse.subjectId;
    },
  },
  watch: {
    selectedCourse() {
      this.getCourseTree();
    },
    courseList(v) {
      if (v && v.length) {
        this.$nextTick(this.initGuide);
      }
    },
  },
  mounted() {
    this.initGuide();
    this.getCourseList();
  },
  methods: {
    getCourseList(courseName, page = 1, limit = 10) {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const isProd = !window.location.host.includes('test') && !window.location.port.includes('8080');
      const campusId = isProd ? '20011' : '88902';
      const param = {
        teacher_id: unlocking('Master_Sale_Manager') ? 0 : userInfo.id,
        course_name: courseName,
        page: page || 1,
        page_size: limit || 10,
        campus_id: JSON.parse(localStorage.getItem('CRM_USER_INFO') || '{}').campusId || campusId,
      };
      param.sign = getSign(param);
      return getCourseList(param).then((res) => {
        if (res.code === 200) {
          this.courseCount = res.data.total_count;
          if (page === 1) {
            this.courseList = res.data.course_list;
            const cachedCourseId = _.get(JSON.parse(localStorage.getItem(CACHED_LO + this.userInfo.id)), '0.courseId');
            this.selectedCourse = cachedCourseId || res.data.course_list[0].course_id;
          } else {
            this.courseList = this.courseList.concat(res.data.course_list);
          }
        }
      }).then(this.getCourseTree);
    },
    getCourseTree() {
      const param = {
        course_id: this.selectedCourse,
      };
      param.sign = getSign(param);
      return getCourseTree(param).then((res) => {
        if (res.code === 200) {
          this.chapterList = res.data.chapter_list;
          this.courseTreeId = res.data.id;
        }
      }).then(this.initChapterList);
    },
    initGuide() {
      if (this.$refs.container && this.visibleGuide) {
        const dom = this.$refs.container;
        const { left, width, top } = dom.getBoundingClientRect();
        this.pos = {
          x: left + width,
          top,
        };
      }
    },
    initChapterList() {
      const cacheCourseList = JSON.parse(localStorage.getItem(CACHED_LO + this.userInfo.id)) || [];
      const cachedCourse = cacheCourseList.find((item) => item.courseId === this.selectedCourse);
      const currentCourse = this.courseList.find((item) => item.course_id === this.selectedCourse);
      console.log({
        currentCourse, cachedCourse, cacheCourseList, selectedCourse: this.selectedCourse,
      });
      if (!cachedCourse) {
        this.cachedCourse = {
          courseId: currentCourse.course_id,
          courseName: currentCourse.course_name,
          subjectId: currentCourse.subject_id,
          textbookId: currentCourse.textbook_id,
          chapterId: _.get(this.chapterList, '0.id'),
          lessonId: _.get(this.chapterList, '0.lesson_list.0.id'),
          courseTreeId: this.courseTreeId,
          lessonName: _.get(this.chapterList, '0.lesson_list.0.lesson_name'),
        };
      } else {
        this.cachedCourse = cachedCourse;
      }
      this.activatedCourse = this.cachedCourse;
      this.chapterList = this.chapterList.map((item) => ({
        ...item,
        active: this.cachedCourse.chapterId === item.id,
        lesson_list: item.lesson_list.map((lesson) => ({
          ...lesson,
          active: this.cachedCourse.lessonId === lesson.id,
        })),
      }));
    },
    onCloseGuide() {
      this.visibleGuide = false;
      localStorage.setItem(GUIDE + this.userInfo.id, 1);
    },
    onToggle(item) {
      // eslint-disable-next-line no-param-reassign
      item.active = !item.active;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-resource {
  display: flex;
  .f-left {
    width: 2.56rem;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    padding-top: 6px;
    min-height: 780px;
    z-index: 2;
  }
  .f-main {
    flex: 1;
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
  }
  .selector-container {
    margin-bottom: 30px;
  }
}
</style>
